import { render, staticRenderFns } from "./parcelcode-add.vue?vue&type=template&id=40b7fcd2"
import script from "./parcelcode-add.vue?vue&type=script&lang=js"
export * from "./parcelcode-add.vue?vue&type=script&lang=js"
import style0 from "./parcelcode-add.vue?vue&type=style&index=0&id=40b7fcd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports